import React, { useState, useRef, useEffect, useContext } from "react";
import AssetType from "../Asset Type/AssetType";
import styles from "./styles/AddNewAsset.module.css";
import AddAsset from "../Add Asset/AddAsset";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
function AddNewAsset({ assets, onClick, alreadySelected, openAssets }) {
  const [options, showOptions] = useState(false);
  const [modal, setModal] = useState();
  const wrapperRef = useRef(null);
  const [blink, setBlink] = useState(false);
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AddBeneficiary.AddNewAsset
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AddBeneficiary.AddNewAsset);
  }, [websiteCurrentLang]);
  const handleElection = () => {
    // showOptions(false)
    return;
  };
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        event.target.innerText !== "OK"
      ) {
        showOptions(false);
        setBlink(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    if (openAssets) {
      setBlink(true);
      showOptions(true);
    }
  }, [openAssets]);
  return (
    <div
      onClick={() => showOptions(!options)}
      ref={wrapperRef}
      className={styles.main}
    >
      <div className={styles.add_asset}>
        <div className={styles.plus} />
      </div>
      <div className={styles.add_new_asset_text}>
        {content.addNewAssetText1}
      </div>
      {options ? (
        <>
          <div
            onClick={(e) => e.stopPropagation()}
            className={`${styles.options} ${blink ? styles.blink : ""}`}
          >
            <div
              style={{ width: "100%", height: "20px", position: "relative" }}
            >
              <div
                onClick={() => showOptions(false)}
                className={styles.close}
              />
            </div>
            <div
              onClick={() => {
                /*
                  A new asset is attached to this record as well as created.

                  Without this the asset was made and then went nowhere: the
                  list the reader was standing in front of did not gain it,
                  and the only way to attach it was to find it again in this
                  same dropdown afterwards. For a PARTNER it was worse than
                  an inconvenience -- the attachment is the half the customer
                  reviews, so an asset created here reached them with nothing
                  saying which beneficiary it was meant for.

                  `onClick` is the dropdown's own "this one" -- the same path
                  as picking an existing asset, so the id lands wherever the
                  owner of this control puts it. For a partner that is a
                  proposal on the beneficiary; for a customer it is the list.
                */
                setModal(
                  <AddAsset
                    onClose={() => setModal(null)}
                    onCreated={(asset_id) =>
                      asset_id && onClick({ asset_id })
                    }
                  />
                );
              }}
              className={`${styles.option_cell} ${styles.option_cell_add}`}
            >
              <div className={styles.add_asset}>
                <div className={styles.plus} />
              </div>
              {content.addNewAssetText1}
            </div>
            {assets
              ?.filter((e) => !alreadySelected.includes(e.asset_id))
              .map((asset) => {
                return (
                  <div
                    key={asset.asset_id}
                    onClick={() => {
                      onClick(asset);
                      handleElection();
                    }}
                    className={styles.option_cell}
                  >
                    <AssetType
                      list={true}
                      key={asset.asset_id}
                      asset_type={asset.asset_type}
                      asset_name={asset.asset_name}
                      removable={false}
                    />
                  </div>
                );
              })}
          </div>
        </>
      ) : null}

      {/*
        The Add Asset modal hangs off the component, not off the dropdown.

        It used to be a child of `.options`, which is
        `position: absolute; z-index: 2` -- a stacking context. A modal
        nested in one cannot climb out: its own `z-index: 60` only ranks
        it among that dropdown's children, so the beneficiary modal
        underneath painted its scroll marker and its dividers straight
        over the top of it.

        Out here it ranks in the beneficiary modal's own context, where
        60 puts it above. It also survives the dropdown closing, which
        it did not when the list and the modal shared one conditional.

        The click guard replaces the one `.options` was providing: without
        it every click inside the modal reaches the root div's onClick and
        toggles the list underneath.
      */}
      {modal && <div onClick={(e) => e.stopPropagation()}>{modal}</div>}
    </div>
  );
}

export default AddNewAsset;
